module.exports = __webpack_public_path__ + "static/media/gamfiLogo.36624b3f.svg";